import { passResetProps } from "../../pages/reilogspf/Reilogspf002";

/**
 * パスワード再設定　変更ボタン押下時の入力チェック
 */
export function passResetValidate(props:passResetProps){
    const message: string[] = [];

    const name = props?.name;
    const pass1 = props?.password1;
    const pass2 = props?.password2;

    //  NULLチェック
    if(isNullCheck(name) && isNullCheck(pass1) && isNullCheck(pass2)){
        message.push('氏名、新しいパスワード、新しいパスワード（再確認）は必須項目です。');
    }else{
        if(isNullCheck(name)){
            message.push('氏名は必須項目です。');
        }
        if(isNullCheck(pass1)){
            message.push('新しいパスワードは必須項目です。');
        }
        if(isNullCheck(pass2)){
            message.push('新しいパスワード（再確認）は必須項目です。')
        }

        if(!isNullCheck(pass1) && !isNullCheck(pass2)){

            if(pass1.length < 8 || pass2.length < 8 || pass1.length > 50 || pass2.length > 50){
                message.push('パスワードは8文字以上50文字以内で入力してください');

            }else{
                if(pass1 !== pass2){
                    message.push('新しいパスワードと新しいパスワード（再確認）が一致しません');
                }
                //  パスワードの入力規則チェック
                const regax =  /(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_,.`~?"':;+=\-{}|<>/])/;
                if(!regax.test(pass1) || !regax.test(pass2)){
                    message.push('パスワードは半角英数字・記号を交えて入力してください');
                }
            }
        }
    }

    return message;
}

function isNullCheck(str: string){
    if(str == undefined || str === ''){
        return true;
    }
    return false;
}